<template>
  <ListFilterForm
    :is-filter-enabled="props.isFilterEnabled"
    :initial-filter="initialFilter"
    @toggle-filter="emits('toggleFilter')"
    @set-filter="setParentFilter"
  >
    <template #fields="slotProps">
      <div class="flex flex-col">
        <label for="segmentMame" class="small-label"
          >Наименование кабинета</label
        >
        <InputText
          id="segmentMame"
          placeholder="Введите название"
          v-model="slotProps.filter.name"
          aria-describedby="username-help"
        />
      </div>

      <div class="flex flex-col m-t-8">
        <label for="login" class="small-label">Логин</label>
        <InputText
          id="login"
          placeholder="Введите логин"
          v-model="slotProps.filter.login"
          aria-describedby="login-help"
        />
      </div>

      <div class="flex flex-col m-t-8">
        <label for="external_id" class="small-label">Внешний id</label>
        <InputText
          id="external_id"
          placeholder="Введите внешний id"
          v-model="slotProps.filter.external_id"
          aria-describedby="external_id-help"
        />
      </div>

      <div class="flex flex-col m-t-8">
        <label for="state" class="small-label">Площадка</label>
        <CatalogDataBaseInput
          :not-search="true"
          :useIdOnly="true"
          selectType="source"
          :isSegmentSetted="false"
          :modelValue="slotProps.filter.source_slug"
          @update:modelValue="
            ($event) => (slotProps.filter.source_slug = $event)
          "
        ></CatalogDataBaseInput>
      </div>

      <div class="flex flex-col m-t-8">
        <label class="small-label">Имена кампаний проверяются в SSP</label>
        <div class="fl m-b-8 m-t-4">
          <RadioButton
            v-model="slotProps.filter.is_naming_checked"
            inputId="yes"
            name="active"
            value="1"
          />
          <label for="yes" class="p-l-4">Да</label>
        </div>
        <div class="fl">
          <RadioButton
            v-model="slotProps.filter.is_naming_checked"
            inputId="no"
            name="active"
            value="0"
          />
          <label for="no" class="p-l-4">Нет</label>
        </div>
      </div>

      <div class="flex flex-col m-t-8">
        <label class="small-label">Использовать в UI</label>
        <div class="fl m-b-8 m-t-4">
          <RadioButton
            v-model="slotProps.filter.use_in_ui"
            inputId="use_in_ui_yes"
            name="use_in_ui"
            value="1"
          />
          <label for="use_in_ui_yes" class="p-l-4">Да</label>
        </div>
        <div class="fl">
          <RadioButton
            v-model="slotProps.filter.use_in_ui"
            inputId="use_in_ui_no"
            name="use_in_ui"
            value="0"
          />
          <label for="use_in_ui_no" class="p-l-4">Нет</label>
        </div>
      </div>

      <div class="flex m-t-18 m-b-8 fl-jc-sb">
        <label for="updated">Статистика собирается в SSP</label>
        <InputSwitch
          v-model="slotProps.filter.is_statistics_required"
          inputId="updated"
        />
      </div>
    </template>
  </ListFilterForm>
</template>

<script setup lang="ts">
import InputText from "primevue/inputtext";
import InputSwitch from "primevue/inputswitch";
import CatalogDataBaseInput from "@/widgets/forms/CatalogDataBaseInput.vue";
import ListFilterForm from "@/widgets/forms/ListFilterForm.vue";
import RadioButton from "primevue/radiobutton";

const props = defineProps<{
  isFilterEnabled: boolean;
}>();
const emits = defineEmits(["toggleFilter", "setFilter"]);

const initialFilter = {
  name: "",
  login: "",
  external_id: "",
  source_slug: [] as string[],
  is_statistics_required: true,
  is_naming_checked: "",
  use_in_ui: "",
};

const setParentFilter = (filter: any, isSetted: boolean) => {
  emits("setFilter", filter, isSetted);
};
</script>
